var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "maintenance" }, [
    _c("div", { staticClass: "gradient-panel" }, [
      _c("div", { staticClass: "content-area" }, [
        _c("div", { staticClass: "grid-x grid-padding-x" }, [
          _c(
            "div",
            { staticClass: "cell small-12 medium-6 medium-offset-3 center" },
            [
              _c("img", {
                staticClass: "backsoon-image",
                attrs: { src: _vm.getImage("backsoon.png") }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "cell small-12 center" }, [
            _c("h2", [_vm._v(_vm._s(_vm.strings.header))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cell small-12 center" }, [
            _vm._v("\n          " + _vm._s(_vm.strings.details) + "\n        ")
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fb06f93", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fb06f93","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Maintenance.vue
// module id = null
// module chunks = 